function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { createOwnUpComponent } from '../../components';
import { OwnUpText } from '../../typography/text';
import { DEPRECATED_ICONS } from './deprecated';
import { OwnUpIconStyle } from './style';
import * as SVGS from './svgs';
export var OwnUpStyledIcon = createOwnUpComponent('span', OwnUpIconStyle);
/**
 * Render a span that contains a defined icon.
 *
 * @param props See {@link OwnUpIconProps}
 */

export var OwnUpIcon = function OwnUpIcon(props) {
  if (DEPRECATED_ICONS.includes(props.icon)) {
    console.warn("OwnUpIcon '".concat(props.icon, "' has been deprecated and moved to OwnUpArtwork. It will be removed as a valid option soon."));
  } // Atempt to render the requested icon.


  var svgFunc = SVGS[props.icon];
  var icon = svgFunc ? // Populate default color if needed
  svgFunc(props) :
  /*#__PURE__*/
  // Return an error indication if no icon found.
  React.createElement(OwnUpText, {
    variant: "devError"
  }, props.icon); // Fill is boolean here so we remove it to avoid a type clash

  var fill = props.fill,
      cleanedProps = _objectWithoutProperties(props, ["fill"]);

  return /*#__PURE__*/React.createElement(OwnUpStyledIcon, cleanedProps, icon);
};